import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPython } from "@fortawesome/free-brands-svg-icons";
import { faDesktop, faFileCode, faMobile } from '@fortawesome/free-solid-svg-icons';

const Services = () => {
    return (
        <div id="services" className="services">
            <h1 className="py-5"> my services </h1>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className='box'>
                            <div className="circle">
                                <FontAwesomeIcon className="icon" icon={faDesktop} size="2x" />
                            </div>
                            <h3>Web Design</h3>
                            <p>I can design the sketch for an web application with all the user requirments</p>
                        </div>
                    </div>
                    {/*  */}
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className='box'>
                            <div className="circle">
                                <FontAwesomeIcon className="icon" icon={faFileCode} size="2x" />
                            </div>
                            <h3>Web Development</h3>
                            <p>The website will be built with an new proven technologies</p>
                        </div>
                    </div>
                    {/*  */}
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className='box'>
                            <div className="circle">
                                <FontAwesomeIcon className="icon" icon={faMobile} size="2x" />
                            </div>
                            <h3>Android Application Developer</h3>
                            <p>Android applications will be built on user requirments with new technologies</p>
                        </div>
                    </div>
                    {/*  */}
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className='box'>
                            <div className="circle">
                                <FontAwesomeIcon className="icon" icon={faPython} size="2x" />
                            </div>
                            <h3>Python Developer</h3>
                            <p>I will code some Python snippets with a good working</p>
                        </div>
                    </div>
                    {/*  */}
                </div>
            </div>
        </div>


    )
}

export default Services
